/** @format */

const newColors = [
  "#2459EA", // 0%
  "#2E7AEF", // 10%
  "#3698F4", // 15%
  "#3EAAFD", // 20%
  "#49B2FC", // 28%
  "#55B5FF", // 35%
  "#6BAEFF", // 45%
  "#7C9EFF", // 52%
  "#8490FF", // 56%
  "#8A80F5", // 61%
  "#886EFF", // 65%
  "#A067E8", // 74%
  "#C950DA", // 85%
  "#FD26A1", // 92%
] as const;

// Centralized gradient definitions for the entire application
export const GRADIENTS = {
  // Main brand gradient - the primary colorful gradient used across the app
  MAIN_BRAND: `linear-gradient(to right, ${newColors[0]}, ${newColors[3]}, ${newColors[6]}, ${newColors[9]}, ${newColors[11]}, ${newColors[13]})`,

  // Border/outline gradient variation
  BORDER: `linear-gradient(to right bottom, ${newColors[1]}, ${newColors[4]}, ${newColors[7]}, ${newColors[10]}, ${newColors[12]}, ${newColors[13]})`,

  // Individual shade gradients (existing getGradientShade variants)
  SHADE_1: `linear-gradient(to right, ${newColors[2]}, ${newColors[8]})`,
  SHADE_2: `linear-gradient(to right, ${newColors[5]}, ${newColors[11]})`,
  SHADE_3: `linear-gradient(to right, ${newColors[9]}, ${newColors[13]})`,
} as const;

// Legacy function for backward compatibility
export const getGradientShade = (index: number) => {
  const id = index % 3;
  switch (id) {
    case 0:
      return GRADIENTS.SHADE_1;
    case 1:
      return GRADIENTS.SHADE_2;
    case 2:
      return GRADIENTS.SHADE_3;
    default:
      return "red";
  }
};

// Helper function to get the main brand gradient
export const getMainGradient = () => GRADIENTS.MAIN_BRAND;

// Helper function to get border gradient
export const getBorderGradient = () => GRADIENTS.BORDER;
